import React, { useEffect } from 'react';

type StaticLegalRedirectProps = {
  path: '/privacy/' | '/terms/';
};

/** SPA fallback: hard-navigate to crawler-friendly static legal HTML. */
const StaticLegalRedirect: React.FC<StaticLegalRedirectProps> = ({ path }) => {
  useEffect(() => {
    window.location.replace(path);
  }, [path]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-black text-white">
      <p className="text-sm text-white/50">Loading legal page…</p>
    </div>
  );
};

export const PrivacyRoutePage: React.FC = () => (
  <StaticLegalRedirect path="/privacy/" />
);

export const TermsRoutePage: React.FC = () => (
  <StaticLegalRedirect path="/terms/" />
);
